import phoneHome from "./phoneHome";
const et = {
    phoneHome,
};
export default et;
